import getters from './leadGenGetters'
import actions from './leadGenActions'
import mutations from './leadGenMutations'

const store = {
  namespaced: true,
  state: () => ({
    currentQuestion: 'Question 1',
    answers: [{
      question: 'Question 1',
      answer: 'Answer 1'
    }],
    questionFlowData: {}
  }),
  getters,
  actions,
  mutations
}

export default store
